import SwitchComponent from './SwitchComponent';

export default SwitchComponent;
